import { p as t } from "./Request-6aaae745.mjs";
const u = "/compaymentas/v1", n = (a) => a + u, o = {
  get basePath() {
    return `${ApiConfigService.getBaseUrl()}${u}`;
  },
  async getBanksList(a) {
    return await t.get({
      url: `${a != null && a.baseURL ? n(a.baseURL) : this.basePath}/bank-details`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  async getAllBanksList(a, e) {
    return await t.post({
      url: `${e != null && e.baseURL ? n(e.baseURL) : this.basePath}/bank-details`,
      body: a,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  async getAccountBasedBanks(a, e) {
    return await t.get({
      url: `${e != null && e.baseURL ? n(e.baseURL) : this.basePath}/bank-accounts?accountUsage=${a}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  async getBanksAccounts(a, e, s) {
    return await t.get({
      url: `${s != null && s.baseURL ? n(s.baseURL) : this.basePath}/bank-accounts?accountId=${a}&accountUsage=${e}`,
      ...(s == null ? void 0 : s.headers) && { headers: s == null ? void 0 : s.headers }
    });
  },
  async addBankAccount(a, e, s) {
    return await t.post(
      {
        url: `${s != null && s.baseURL ? n(s.baseURL) : this.basePath}/bank-accounts`,
        body: a,
        headers: {
          "X-Idempotency-Key": e,
          ...s == null ? void 0 : s.headers
        }
      },
      {
        skipIdempotency: !0,
        skipDefaultContentType: !0
      }
    );
  },
  async getAddedBankList(a) {
    return await t.get({
      url: `${a != null && a.baseURL ? n(a.baseURL) : this.basePath}/bank-accounts`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  async getBankDetailsById(a, e, s) {
    return await t.get({
      url: `${s != null && s.baseURL ? n(s.baseURL) : this.basePath}/bank-accounts/${a}?accountUsage=${e}`,
      ...(s == null ? void 0 : s.headers) && { headers: s == null ? void 0 : s.headers }
    });
  },
  async updateBankAccount(a, e, s, l) {
    return await t.put({
      url: `${l != null && l.baseURL ? n(l.baseURL) : this.basePath}/bank-accounts/${s}`,
      body: a,
      headers: {
        "X-Idempotency-Key": e,
        ...l == null ? void 0 : l.headers
      }
    });
  }
};
export {
  o as U
};
//# sourceMappingURL=BankAccountApi-5392d0e0.mjs.map
